export default __webpack_public_path__ + "static/media/exterior8.e3c92463.webp";